// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#range-date[data-v-c19237e2]  input.form-control.input{border-radius:.357rem 0 0 .357rem;border-right:none}", ""]);
// Exports
module.exports = exports;
